/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
// web方式兜底
var setClipboard = function (args) {
    var _a = args || {}, _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.success, success = _c === void 0 ? function () { } : _c, _d = _a.fail, fail = _d === void 0 ? function () { } : _d, _e = _a.complete, complete = _e === void 0 ? function () { } : _e;
    var input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', text);
    input.style.position = 'fixed';
    input.style.height = '0px';
    document.body.appendChild(input);
    input.focus();
    input.setSelectionRange(0, -1);
    var removeInput = function () {
        document.body.removeChild(input);
    };
    try {
        if (document.execCommand('copy')) {
            removeInput();
            success({ success: true });
            complete({ success: true });
        }
        else {
            removeInput();
            fail({
                errCode: 1,
                errMsg: 'not support',
            });
        }
    }
    catch (error) {
        removeInput();
        fail({
            errCode: 11,
            errMsg: JSON.stringify(error),
        });
    }
};

export { setClipboard as default };
